'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import MuiLink, { LinkProps } from '@mui/material/Link';
import MuiOpenInNewIcon from '@mui/icons-material/OpenInNew';
import { styled } from '../styles';
import { Variant as TypographyVariant } from '../Typography';
type Variant = 'default' | 'small' | 'large';
type Color = 'primary' | 'secondary';
export interface Props extends Omit<LinkProps, 'component' | 'variant' | 'color'> {
  to?: string;
  variant?: Variant;
  color?: Color;
  component?: ReactNode;
}
const OpenInNewIcon = styled(MuiOpenInNewIcon)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  color: palette.icon.minor,
  fontSize: '1rem',
  marginLeft: spacing(0.5),
  position: 'relative',
  top: 4
}));
const Link = styled(MuiLink, {
  shouldForwardProp: prop => !['shouldHaveUnderline'].includes(prop as string)
})<{
  shouldHaveUnderline: boolean;
}>(({
  shouldHaveUnderline
}) => ({
  fontFamily: 'inherit',
  ...(shouldHaveUnderline ? {
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none'
    }
  } : {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  })
}));
const Hyperlink = t0 => {
  const $ = _c(25);
  let children;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let target;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      color: t2,
      target,
      underline: t3,
      sx: t4,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = target;
  } else {
    children = $[1];
    otherProps = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    target = $[7];
  }
  const variant = t1 === undefined ? "default" : t1;
  const color = t2 === undefined ? "primary" : t2;
  const underline = t3 === undefined ? "always" : t3;
  let t5;
  if ($[8] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const sx = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      default: "hyperlink",
      small: "hyperlinkSmall",
      large: "hyperlinkLarge"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const typographyMapping = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      primary: "interaction.enabled",
      secondary: "interaction.navigationEnabled"
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const colorMapping = t7;
  const shouldOpenInNewTab = target === "_blank";
  const shouldHaveUnderline = underline !== "none" && variant !== "large";
  const t8 = typographyMapping[variant];
  const t9 = colorMapping[color];
  let t10;
  if ($[12] !== sx || $[13] !== t9) {
    t10 = {
      color: t9,
      cursor: "pointer",
      ...sx
    };
    $[12] = sx;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== children || $[16] !== otherProps || $[17] !== shouldHaveUnderline || $[18] !== t10 || $[19] !== t8 || $[20] !== target) {
    t11 = <Link shouldHaveUnderline={shouldHaveUnderline} variant={t8} sx={t10} target={target} {...otherProps}>{children}</Link>;
    $[15] = children;
    $[16] = otherProps;
    $[17] = shouldHaveUnderline;
    $[18] = t10;
    $[19] = t8;
    $[20] = target;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const linkElement = t11;
  let t12;
  if ($[22] !== linkElement || $[23] !== shouldOpenInNewTab) {
    t12 = shouldOpenInNewTab ? <span>{linkElement}<OpenInNewIcon /></span> : linkElement;
    $[22] = linkElement;
    $[23] = shouldOpenInNewTab;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
export default Hyperlink;